<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-14 08:39:08
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-22 09:24:30
-->
<template>
  <div class="main-header">
    <div class="main-header-logo">
      <router-link to="/" class="logoLink">
        <img src="@/assets/logo.png" alt="" />
        湖北长江互联网教育研究院职业技能等级考试系统
      </router-link>
    </div>
    <div class="main-header-main">
      <user-dropdown></user-dropdown>
    </div>
  </div>
</template>
<script>
import UserDropdown from '../UserDropdown'
export default {
  components: {
    UserDropdown,
  },
  computed: {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.backHome {
  display: flex;
  color: #606266;
  font-size: 14px;
  span {
    margin-left: 5px;
    line-height: 68px;
  }
}
</style>
